/* eslint-disable no-param-reassign */
const TOWER_API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // UPDATE
const TOWER_API_DEPARTMENT = process.env.REACT_APP_API_DEPARTMENT; // UPDATE
const TOWER_API_AUTHORIZATION = process.env.REACT_APP_API_AUTHORIZATION; // UPDATE
const TOWER_API_SUBSCRIPTION = process.env.REACT_APP_API_SUBSCRIPTION; // UPDATE
const TOWER_API_CURRENCY = process.env.REACT_APP_API_CURRENCY; // UPDATE

const TOWER_API = process.env.REACT_APP_WITWAN_WEB; // WITWAN
const TOWER_API_USER = process.env.REACT_APP_API_USER;

async function callApi(origin, endpoint, options = {}) {
  options.headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...options.headers, // UPDATE
  };

  const url = origin + endpoint;

  const response = await fetch(url, options);

  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;

    throw error;
  }

  const data = await response.json();

  return data;
}

const api = {
  validateUser: {
    get({ token, language }) {
      return callApi(`${TOWER_API_BASE_URL}/${TOWER_API_AUTHORIZATION}`, '/token', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Accept-Language': language,
        },
      });
    },
  },
  images: {
    heroSlider() {
      return callApi(TOWER_API_BASE_URL, '/banners/public/partners', {
        cache: 'no-cache',
        method: 'GET',
      });
    },
    featured() {
      return callApi(TOWER_API_BASE_URL, '/featured/public/partners', {
        cache: 'no-cache',
        method: 'GET',
      });
    },
    promotions() {
      return callApi(TOWER_API_BASE_URL, '/unmissablepromo/public/partners', {
        cache: 'no-cache',
        method: 'GET',
      });
    },
  },
  login: {
    get(token) {
      return callApi(TOWER_API, `/login/get?cred=${token}`);
    },
  },
  prices: {
    // Nueva colleccion currencies para traer la info sin auntenticacion
    get() {
      return callApi(`${TOWER_API_BASE_URL}/${TOWER_API_CURRENCY}`, '/webquotation', {
        method: 'GET',
      });
    },
  },
  contact: {
    subscription({ email, language }) {
      return callApi(`${TOWER_API_BASE_URL}/${TOWER_API_SUBSCRIPTION}`, '', {
        method: 'POST',
        headers: {
          'Accept-Language': language,
        },
        body: JSON.stringify({
          email,
          department: TOWER_API_DEPARTMENT,
        }),
      });
    },
  },
  whatsapp: {
    get({ language }) {
      return callApi(
        `${TOWER_API_BASE_URL}/${TOWER_API_USER}`,
        `/whatsapp/${TOWER_API_DEPARTMENT}`,
        {
          method: 'GET',
          headers: {
            'Accept-Language': language,
          },
        }
      );
    },
  },
  popup: {
    get() {
      return callApi(TOWER_API_BASE_URL, '/popup/public/partners', {
        cache: 'no-cache',
        method: 'GET',
      });
    },
  },
};

export default api;
